// this comment tells babel to convert jsx to calls to a function called jsx instead of React.createElement
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/react";

//CSS
const styled = {
  cta: css`
    font-family: "p22-mackinac-pro", Georgia, "Times New Roman", times, serif;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 165%;
    bottom: 0;
    text-decoration-line: underline;

    a:any-link {
      color: #975936;
    }

    @media screen and (max-width: 800px) {
      display: block;
    }
  `,
};

export default function CTA(props) {
  // if (props.CTA && props.CTA.id === props.nid) {
  //   return (
  //       <div css={styled.cta}>
  //         <a href={props.CTA.cta.url}>{props.CTA.cta.label} ></a>
  //       </div>
  //   );
  // } else {
  //   return <div></div>;
  // }
  return (
    <div css={styled.cta}>
      <a href={props.CTA.url}>{props.CTA.label}</a>
    </div>
  );
}
